// Guided Programs: all data from Jake's Uscreen store (videos.feelingmoved.com), re-read 2026-10-30 (Phase 9).
// Edit here only. about/whoFor/highlights/signoff are Uscreen copy, verbatim. Generated by /app/scripts/build_programs_p9.py.
export const PROGRAMS_SOURCE = "https://videos.feelingmoved.com/categories/programsandchallenges";

export const PROGRAM_GROUPS = [
  { id: "begin", label: "Begin Here" },
  { id: "meditation", label: "Meditation" },
  { id: "challenge", label: "Short Challenges" },
  { id: "journey", label: "Month-long Journeys" },
];

export const PROGRAMS = [
  {
    "slug": "yoga-for-beginners-in-21-days",
    "title": "YOGA FOR BEGINNERS IN 21 DAYS",
    "uscreenPageTitle": "YOGA FOR BEGINNERS IN 21 DAYS",
    "displayTitle": "Yoga for Beginners in 21 Days",
    "subtitle": "Give yourself a welcoming place to begin.",
    "group": "begin",
    "length": "21 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/21_day_beginner",
    "image": "/media/programs/yoga-for-beginners-in-21-days.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1005895/horizontal/big_BEGIN.001.1633207501.jpeg",
    "imageAlt": "YOGA FOR BEGINNERS IN 21 DAYS program cover",
    "about": [
      "This 21-day program introduces you to yoga through approachable practices that help you become more comfortable with movement, breath and the foundations of the practice.",
      "You’ll begin with shorter sessions exploring basic movements and sun salutations, then gradually build toward longer flows. Many classes include a second person demonstrating modifications, so you can see different ways to approach the poses and find what works for your body.",
      "Rest days are built into the journey, giving you time to recover, absorb what you’re learning and return feeling ready for your next practice.",
      "You’ll also receive three bonus five-minute practices. These quick stretches are easy to return to whenever you want a little movement—on a busy morning, during a break or every day if you wish."
    ],
    "whoFor": [
      "Take your time, repeat a class whenever it feels helpful and allow yourself to learn as you go. You don’t need to know the poses or be flexible to start."
    ],
    "highlights": [
      "A guided 21-day journey with planned rest days",
      "16 practice videos to build your foundation",
      "Three bonus five-minute practices you can use anytime",
      "Modifications to help you explore poses at your own level",
      "One year of access to all 19 videos"
    ],
    "signoff": [],
    "videoCount": 19,
    "restDays": 5,
    "breakdown": {
      "practices": 16,
      "intros": 0,
      "bonus": 3
    },
    "totalMinutes": 456,
    "price": {
      "label": "Rent $111.00",
      "amount": "$111.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1005895"
    },
    "sessions": [
      {
        "label": "DAY 1 - QUICK STRETCH",
        "videos": [
          {
            "title": "YOGA FLOW - Everyday Stretch and Flow",
            "duration": "15:56"
          }
        ]
      },
      {
        "label": "DAY 2 - BEGINNER STEP BY STEP",
        "videos": [
          {
            "title": "YOGA - Beginner Step by Step",
            "duration": "11:51"
          }
        ]
      },
      {
        "label": "DAY 3 - SUN SALUTATIONS A",
        "videos": [
          {
            "title": "Sun Salutation A",
            "duration": "07:31"
          }
        ]
      },
      {
        "label": "DAY 4 - SUN SALUTATIONS B",
        "videos": [
          {
            "title": "Sun Salutation B",
            "duration": "09:38"
          }
        ]
      },
      {
        "label": "DAY 5 - FULL BODY PRACTICE WITH MODIFICATIONS",
        "videos": [
          {
            "title": "YOGA FLOW - Full Body Practice",
            "duration": "31:12"
          }
        ]
      },
      {
        "label": "DAY 6 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 7 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 8 - FLOOR SERIES",
        "videos": [
          {
            "title": "YOGA FLOW - Everyday Floor",
            "duration": "24:46"
          }
        ]
      },
      {
        "label": "DAY 9 - SEATED SERIES",
        "videos": [
          {
            "title": "GET UP SIT UP",
            "duration": "15:35"
          }
        ]
      },
      {
        "label": "DAY 10 - SLOW FLOW & MEDITATE",
        "videos": [
          {
            "title": "SLOW FLOW & MEDITATION",
            "duration": "42:05"
          }
        ]
      },
      {
        "label": "DAY 11 - BUILDING A STRONGER BACK",
        "videos": [
          {
            "title": "YOGA FLOW - STRONGER BACK",
            "duration": "32:59"
          }
        ]
      },
      {
        "label": "DAY 12 - HEART OPENING FLOW WITH MODIFICATIONS",
        "videos": [
          {
            "title": "YOGA FLOW - Heart Opening Flow",
            "duration": "36:45"
          }
        ]
      },
      {
        "label": "DAY 13 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 14 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 15 - YOGA FLOW - BALANCE",
        "videos": [
          {
            "title": "YOGA FLOW - 30 MIN BALANCE",
            "duration": "29:14"
          }
        ]
      },
      {
        "label": "DAY 16 - YOGA FLOW - TWISTING",
        "videos": [
          {
            "title": "YOGA FLOW - Twisted Quickie",
            "duration": "30:59"
          }
        ]
      },
      {
        "label": "DAY 17 - YOGA FLOW - JOY",
        "videos": [
          {
            "title": "YOGA FLOW - Joy through Awareness",
            "duration": "30:54"
          }
        ]
      },
      {
        "label": "DAY 18 - YOGA FLOW - GRATITUDE",
        "videos": [
          {
            "title": "YOGA FLOW - Flowing into Gratitude",
            "duration": "29:35"
          }
        ]
      },
      {
        "label": "DAY 19 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 20 - YOGA & MEDITATION",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Mellow Magic",
            "duration": "01:00:46"
          }
        ]
      },
      {
        "label": "DAY 21 - OM",
        "videos": [
          {
            "title": "YOGA FLOW - Flowing into a place of creation",
            "duration": "30:02"
          }
        ]
      },
      {
        "label": "BONUS VIDEOS - 5 MIN QUICKIES",
        "videos": [
          {
            "title": "5 MINUTE QUICKIE - Floor Stretches",
            "duration": "05:42"
          },
          {
            "title": "5 MINUTE QUICKIE - Standing Stretches",
            "duration": "05:32"
          },
          {
            "title": "5 MINUTE QUICKIE - Lower Body + Spine",
            "duration": "05:27"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "beginner-startup-program",
    "title": "Beginner Startup Program",
    "uscreenPageTitle": "Beginner Startup Program",
    "displayTitle": "Beginner Startup Program",
    "subtitle": "Begin your yoga practice with a little guidance and encouragement along the way.",
    "group": "begin",
    "length": "7 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/beginnerchallenge",
    "image": "/media/programs/beginner-startup-program.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/429357/horizontal/big_e8238588-5fb8-404c-8607-ca83bb8ae473.jpeg",
    "imageAlt": "Beginner Startup Program program cover",
    "about": [
      "If you’re new to yoga or looking to return to the basics, this seven-day program gives you a welcoming place to start. Explore movement, connect with your breath and become more comfortable on your mat, one practice at a time.",
      "Each day for seven days, you’ll receive an email from me guiding you to your next yoga video. You’ll also have five tutorials to help you understand foundational poses and techniques, so you can revisit the details whenever you need a little extra guidance."
    ],
    "whoFor": [
      "You don’t need to be flexible or know the poses. Just give yourself a place to begin."
    ],
    "highlights": [
      "Seven beginner yoga videos",
      "Five tutorials to support your practice",
      "Daily emails from me throughout the seven days",
      "One year of access to all 12 videos"
    ],
    "signoff": [
      "Follow along each day or take more time with a practice before moving on. You can return to the videos throughout the year as your confidence grows."
    ],
    "videoCount": 12,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 125,
    "price": {
      "label": "Rent $55.00",
      "amount": "$55.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp429357"
    },
    "sessions": [
      {
        "label": null,
        "videos": [
          {
            "title": "YOGA - Beginner Step by Step",
            "duration": "11:51"
          },
          {
            "title": "Sun Salutation A",
            "duration": "07:31"
          },
          {
            "title": "Sun Salutation B",
            "duration": "09:38"
          },
          {
            "title": "YOGA FLOW - Everyday Stretch and Flow",
            "duration": "15:56"
          },
          {
            "title": "GET UP SIT UP",
            "duration": "15:35"
          },
          {
            "title": "YOGA FLOW - Everyday Floor",
            "duration": "24:46"
          },
          {
            "title": "YOGA & MEDITATION - Moon Flow Sequence & Meditation",
            "duration": "21:39"
          },
          {
            "title": "TUTORIAL - VINYASA",
            "duration": "03:48"
          },
          {
            "title": "STEPPING TO FRONT OF THE MAT",
            "duration": "02:57"
          },
          {
            "title": "Warrior 1",
            "duration": "04:09"
          },
          {
            "title": "Warrior 2",
            "duration": "03:11"
          },
          {
            "title": "UJJAYI BREATH",
            "duration": "04:06"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "starting-your-yoga-journey",
    "title": "STARTING YOUR YOGA JOURNEY - 14 days of Yoga & Meditation",
    "uscreenPageTitle": "STARTING YOUR YOGA JOURNEY - 14 days of Yoga & Meditation",
    "displayTitle": "Starting Your Yoga Journey",
    "subtitle": "Move, breathe and make a little space for yourself.",
    "group": "begin",
    "length": "14 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/collection-z3vzeffjhny",
    "image": "/media/programs/starting-your-yoga-journey.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1047220/horizontal/big_START.001.1633206847.jpeg",
    "imageAlt": "STARTING YOUR YOGA JOURNEY - 14 days of Yoga & Meditation program cover",
    "about": [
      "This 14-day program brings yoga and meditation together, helping you build a practice that supports both your body and your awareness.",
      "Each video pairs a yoga practice with a guided meditation, giving you time to move, stretch and build strength before slowing down and noticing how you feel. The classes are welcoming for beginners and offer a thoughtful way to return to the foundations if you’ve practiced before.",
      "Most sessions include around 45 minutes of yoga followed by a 10-minute meditation, with some variation in length."
    ],
    "whoFor": [
      "You don’t need to arrive feeling calm, flexible or ready for everything. Give yourself time to learn, explore and become more comfortable with the practice."
    ],
    "highlights": [
      "14 videos combining yoga and guided meditation",
      "Beginner-friendly practices exploring movement, breath and body awareness",
      "A guided sequence you can follow over two weeks or at your own pace",
      "One year of access to revisit the classes"
    ],
    "signoff": [
      "One class at a time, discover what it feels like to move with awareness and carry a little more presence into your day."
    ],
    "videoCount": 14,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 770,
    "price": {
      "label": "Rent $55.00",
      "amount": "$55.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1047220"
    },
    "sessions": [
      {
        "label": "DAY 1",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Slow Flowing to a Peaceful Place",
            "duration": "58:12"
          }
        ]
      },
      {
        "label": "DAY 2",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Cleaning the Slate",
            "duration": "57:52"
          }
        ]
      },
      {
        "label": "DAY 3",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Mellow Magic",
            "duration": "01:00:46"
          }
        ]
      },
      {
        "label": "DAY 4",
        "videos": [
          {
            "title": "Slow Stretch + Meditate - Feeling into Awareness",
            "duration": "01:08:29"
          }
        ]
      },
      {
        "label": "DAY 5",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Full body flow & Golden Staircase Meditation",
            "duration": "56:28"
          }
        ]
      },
      {
        "label": "DAY 6",
        "videos": [
          {
            "title": "YOGA & MEDITATION - 45 min flow/10 min meditation",
            "duration": "54:42"
          }
        ]
      },
      {
        "label": "DAY 7",
        "videos": [
          {
            "title": "SLOW FLOW & MEDITATION",
            "duration": "42:05"
          }
        ]
      },
      {
        "label": "DAY 8",
        "videos": [
          {
            "title": "YOGA & MEDITATION - 45 min flow/ 10 min Meditation",
            "duration": "54:54"
          }
        ]
      },
      {
        "label": "DAY 9",
        "videos": [
          {
            "title": "YOGA & MEDITATION - 45 min flow -10 min meditation",
            "duration": "57:43"
          }
        ]
      },
      {
        "label": "DAY 10",
        "videos": [
          {
            "title": "YOGA & MEDITATION- Mindfulness & Morricone",
            "duration": "52:59"
          }
        ]
      },
      {
        "label": "DAY 11",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Slow & Calm",
            "duration": "01:02:51"
          }
        ]
      },
      {
        "label": "DAY 12",
        "videos": [
          {
            "title": "YOGA AND MEDITATION",
            "duration": "01:01:12"
          }
        ]
      },
      {
        "label": "DAY 13",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Moon Flow Sequence & Meditation",
            "duration": "21:39"
          }
        ]
      },
      {
        "label": "DAY 14",
        "videos": [
          {
            "title": "YOGA & MEDITATION - Slow Flow Stretch & Meditate",
            "duration": "01:00:30"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "7-days-to-bliss",
    "title": "7 Days to Bliss - Meditation Challenge",
    "uscreenPageTitle": "7 Days to Bliss - Meditation Challenge",
    "displayTitle": "7 Days to Bliss",
    "subtitle": "Make a little space to pause, breathe and reconnect.",
    "group": "meditation",
    "length": "7 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/collection-a9ryfdt6s6a",
    "image": "/media/programs/7-days-to-bliss.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/398982/horizontal/big_f5c6a8b2-354f-477a-99fa-8f19cb975a29.jpeg",
    "imageAlt": "7 Days to Bliss - Meditation Challenge program cover",
    "about": [
      "This seven-day meditation journey offers a different focus each day, inviting you to explore simple ways to feel more grounded, present and connected to yourself.",
      "You’ll begin with a short introduction, followed by seven guided meditations exploring breath, mindfulness, gratitude, body appreciation and more. Each practice offers a new way to work with your attention and discover what supports you."
    ],
    "whoFor": [
      "Whether you’re beginning a meditation practice or finding your way back to one, you’re welcome to start exactly where you are."
    ],
    "highlights": [
      "One introductory video to help you get started",
      "Seven guided meditations, one for each day",
      "Eight videos in total",
      "One year of access to revisit the practices"
    ],
    "signoff": [
      "Follow one meditation each day or move through the collection at your own pace. All videos are accessed directly through the program, so you can choose when to practice and return to a favorite whenever you need it."
    ],
    "videoCount": 8,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 98,
    "price": {
      "label": "Rent $55.00",
      "amount": "$55.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp398982"
    },
    "sessions": [
      {
        "label": null,
        "videos": [
          {
            "title": "7 days to bliss - Meditation",
            "duration": "01:08"
          },
          {
            "title": "FREE MEDITATION - REMINDER TO BREATHE",
            "duration": "05:23"
          },
          {
            "title": "MEDITATION-  MINDFULNESS",
            "duration": "06:02"
          },
          {
            "title": "MEDITATION Transplanted - Coming into a place of hope",
            "duration": "14:15"
          },
          {
            "title": "MEDITATION Growing Light",
            "duration": "10:35"
          },
          {
            "title": "MEDITATION Empowering Breathwork",
            "duration": "17:05"
          },
          {
            "title": "MEDITATION Creating More Gratitude through Awareness",
            "duration": "20:21"
          },
          {
            "title": "MEDITATION Body Appreciation",
            "duration": "23:30"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "21-day-meditation",
    "title": "21 Day Meditation",
    "uscreenPageTitle": "21 Day Meditation",
    "displayTitle": "21 Day Meditation",
    "subtitle": null,
    "group": "meditation",
    "length": "21 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/collection-vjpnyn48sjw",
    "image": "/media/programs/21-day-meditation.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1928059/horizontal/big_MED.001.1666804083.jpeg",
    "imageAlt": "21 Day Meditation program cover",
    "about": [
      "21 days of meditation to help calm the mind and create a reset"
    ],
    "whoFor": [],
    "highlights": [],
    "signoff": [],
    "videoCount": 22,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 234,
    "price": {
      "label": "Rent $111.00",
      "amount": "$111.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1928059"
    },
    "sessions": [
      {
        "label": null,
        "videos": [
          {
            "title": "MEDITATION - Intro Talk",
            "duration": "03:12"
          }
        ]
      },
      {
        "label": "DAY 1",
        "videos": [
          {
            "title": "FREE MEDITATION - REMINDER TO BREATHE",
            "duration": "05:23"
          }
        ]
      },
      {
        "label": "DAY 2",
        "videos": [
          {
            "title": "Meditation - CHECKING IN",
            "duration": "05:42"
          }
        ]
      },
      {
        "label": "DAY 3",
        "videos": [
          {
            "title": "MEDITATION - Raising our Vibrations through Gratitude",
            "duration": "10:31"
          }
        ]
      },
      {
        "label": "DAY 4",
        "videos": [
          {
            "title": "MEDITATION Transplanted - Coming into a place of hope",
            "duration": "14:15"
          }
        ]
      },
      {
        "label": "DAY 5",
        "videos": [
          {
            "title": "HYPNOTIC MEDITATION - Let's go to the beach",
            "duration": "12:51"
          }
        ]
      },
      {
        "label": "DAY 6",
        "videos": [
          {
            "title": "MEDITATION - Redefining Beauty through the Chakras",
            "duration": "14:02"
          }
        ]
      },
      {
        "label": "DAY 7",
        "videos": [
          {
            "title": "HYPNOTIC MEDITATION - Dropping into the Confidence & Beauty Within",
            "duration": "11:05"
          }
        ]
      },
      {
        "label": "DAY 8",
        "videos": [
          {
            "title": "HYPNOTIC MEDITATION -  Relaxation through Imagination",
            "duration": "12:17"
          }
        ]
      },
      {
        "label": "DAY 9",
        "videos": [
          {
            "title": "Meditating through the storm",
            "duration": "12:16"
          }
        ]
      },
      {
        "label": "DAY 10",
        "videos": [
          {
            "title": "MEDITATION - Dropping into our Intended Feeling",
            "duration": "11:04"
          }
        ]
      },
      {
        "label": "DAY 11",
        "videos": [
          {
            "title": "MEDITATION - Finding Love Within",
            "duration": "12:22"
          }
        ]
      },
      {
        "label": "DAY 12",
        "videos": [
          {
            "title": "MEDITATION - Calming the Chaos",
            "duration": "12:56"
          }
        ]
      },
      {
        "label": "DAY 13",
        "videos": [
          {
            "title": "MEDITATION - Love, Gratitude + Joy",
            "duration": "11:39"
          }
        ]
      },
      {
        "label": "DAY 14",
        "videos": [
          {
            "title": "MEDITATION - Feeling Fun, light + Free",
            "duration": "10:42"
          }
        ]
      },
      {
        "label": "DAY 15",
        "videos": [
          {
            "title": "MEDITATION - Expanding Heart Energy",
            "duration": "11:19"
          }
        ]
      },
      {
        "label": "DAY 16",
        "videos": [
          {
            "title": "MEDITATION - Shift to Gratitude",
            "duration": "11:29"
          }
        ]
      },
      {
        "label": "DAY 17",
        "videos": [
          {
            "title": "MEDITATION - Calm State of Mind",
            "duration": "10:12"
          }
        ]
      },
      {
        "label": "DAY 18",
        "videos": [
          {
            "title": "MEDITATION - Heaven's Window",
            "duration": "08:14"
          }
        ]
      },
      {
        "label": "DAY 19",
        "videos": [
          {
            "title": "MEDITATION - Power & Confidence",
            "duration": "12:20"
          }
        ]
      },
      {
        "label": "DAY 20",
        "videos": [
          {
            "title": "MEDITATION - Connecting to the Wave",
            "duration": "08:48"
          }
        ]
      },
      {
        "label": "DAY 21",
        "videos": [
          {
            "title": "MEDITATION - Underlining Layer of Trust",
            "duration": "11:13"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "mindful-and-meditative",
    "title": "MINDFUL & MEDITATIVE - 31 days of meditation",
    "uscreenPageTitle": "MINDFUL & MEDITATIVE - 31 days of meditation",
    "displayTitle": "Mindful & Meditative",
    "subtitle": "31 days of meditation",
    "group": "meditation",
    "length": "31 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/meditations",
    "image": "/media/programs/mindful-and-meditative.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/970251/horizontal/big_MINDFUL.001.1633207101.jpeg",
    "imageAlt": "MINDFUL & MEDITATIVE - 31 days of meditation program cover",
    "about": [
      "This 31 day meditation program has you covered. Each meditation is designed to take you into a deeper sense of calmness and ease.",
      "Throughout the length of 31 days you will go on several meditation journeys and be guided through many ways to help bring your body and mind into a place of peace, relaxation and ease."
    ],
    "whoFor": [],
    "highlights": [],
    "signoff": [],
    "videoCount": 33,
    "restDays": null,
    "breakdown": {
      "practices": 32,
      "intros": 0,
      "bonus": 1
    },
    "totalMinutes": 557,
    "price": {
      "label": "Rent $111.00",
      "amount": "$111.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp970251"
    },
    "sessions": [
      {
        "label": null,
        "videos": [
          {
            "title": "MEDITATION - Intro Talk",
            "duration": "03:12"
          }
        ]
      },
      {
        "label": "DAY 1 - QUICK 5 MIN",
        "videos": [
          {
            "title": "FREE MEDITATION - REMINDER TO BREATHE",
            "duration": "05:23"
          }
        ]
      },
      {
        "label": "DAY 2 - QUICK 6 MIN",
        "videos": [
          {
            "title": "MEDITATION-  MINDFULNESS",
            "duration": "06:02"
          }
        ]
      },
      {
        "label": "DAY 3 - QUICK 6 MIN",
        "videos": [
          {
            "title": "Meditation - CHECKING IN",
            "duration": "05:42"
          }
        ]
      },
      {
        "label": "DAY 4 - QUICK 10 MIN",
        "videos": [
          {
            "title": "MEDITATION Growing Light",
            "duration": "10:35"
          }
        ]
      },
      {
        "label": "DAY 5 - 14 MIN",
        "videos": [
          {
            "title": "MEDITATION Transplanted - Coming into a place of hope",
            "duration": "14:15"
          }
        ]
      },
      {
        "label": "DAY 6 - 8 MIN",
        "videos": [
          {
            "title": "MEDITATION - Quick Reset",
            "duration": "08:23"
          }
        ]
      },
      {
        "label": "DAY 7 - 12 MIN",
        "videos": [
          {
            "title": "MEDITATION - Using the energy of the heart to transform limited belief",
            "duration": "12:34"
          }
        ]
      },
      {
        "label": "DAY 8 - 10 MIN",
        "videos": [
          {
            "title": "MEDITATION - Finding your peaceful place",
            "duration": "10:36"
          }
        ]
      },
      {
        "label": "DAY 9 - 13 MIN",
        "videos": [
          {
            "title": "MEDITATION - Mantra manifestation",
            "duration": "13:16"
          }
        ]
      },
      {
        "label": "DAY 10 - 28 MIN",
        "videos": [
          {
            "title": "MEDITATION- Gratitude for the body",
            "duration": "28:50"
          }
        ]
      },
      {
        "label": "DAY 11 - 27 MIN",
        "videos": [
          {
            "title": "Meditation - Melting away",
            "duration": "27:29"
          }
        ]
      },
      {
        "label": "DAY 12 - 20 MIN",
        "videos": [
          {
            "title": "MEDITATION Creating More Gratitude through Awareness",
            "duration": "20:21"
          }
        ]
      },
      {
        "label": "DAY 13 - 14  MIN",
        "videos": [
          {
            "title": "MEDITATION - Cleansing Storm",
            "duration": "14:01"
          }
        ]
      },
      {
        "label": "DAY 14 - 11 MIN",
        "videos": [
          {
            "title": "MEDITATION - Underlining Layer of Trust",
            "duration": "11:13"
          }
        ]
      },
      {
        "label": "DAY 15 - 8 MIN",
        "videos": [
          {
            "title": "MEDITATION - Connecting to the Wave",
            "duration": "08:48"
          }
        ]
      },
      {
        "label": "DAY 16 - 27 MIN",
        "videos": [
          {
            "title": "MEDITATION - Focusing on Earth Element",
            "duration": "27:45"
          }
        ]
      },
      {
        "label": "DAY 17 - 30 MIN",
        "videos": [
          {
            "title": "MEDITATION - Connecting to the Element of SPACE",
            "duration": "29:26"
          }
        ]
      },
      {
        "label": "DAY 18 - 29 MIN",
        "videos": [
          {
            "title": "Meditation - Connecting to the Element of Air",
            "duration": "28:00"
          }
        ]
      },
      {
        "label": "DAY 19 - 29 MIN",
        "videos": [
          {
            "title": "MEDITATION -  Connecting to the element of Water",
            "duration": "27:28"
          }
        ]
      },
      {
        "label": "DAY 20 - 30 MIN",
        "videos": [
          {
            "title": "MEDITATION - Using the energy of the Fire Element",
            "duration": "26:05"
          }
        ]
      },
      {
        "label": "DAY 21 - 27 MIN",
        "videos": [
          {
            "title": "MEDITATION - 5 ELEMENTS",
            "duration": "27:09"
          }
        ]
      },
      {
        "label": "DAY 22 - 12 MIN",
        "videos": [
          {
            "title": "MEDITATION - Power & Confidence",
            "duration": "12:20"
          }
        ]
      },
      {
        "label": "DAY 23 - 11 MIN",
        "videos": [
          {
            "title": "MEDITATION - Letting Calmness and ease catch up",
            "duration": "11:11"
          }
        ]
      },
      {
        "label": "DAY 24 - 8 MIN",
        "videos": [
          {
            "title": "MEDITATION - Heaven's Window",
            "duration": "08:14"
          }
        ]
      },
      {
        "label": "DAY 25 - 26 MIN",
        "videos": [
          {
            "title": "MEDITATION - Stairs to Tranquility",
            "duration": "26:42"
          }
        ]
      },
      {
        "label": "DAY 26 - 29 MIN",
        "videos": [
          {
            "title": "MEDITATION - Sat Nam Mantra",
            "duration": "29:36"
          }
        ]
      },
      {
        "label": "DAY 27 - 29 MIN",
        "videos": [
          {
            "title": "MEDITATION - OM Mantra",
            "duration": "29:00"
          }
        ]
      },
      {
        "label": "DAY 28 - 28 MIN",
        "videos": [
          {
            "title": "MEDITATION - Expansion of the Heart",
            "duration": "28:18"
          }
        ]
      },
      {
        "label": "DAY 29 - 10 MIN",
        "videos": [
          {
            "title": "MEDITATION - Calm State of Mind",
            "duration": "10:12"
          }
        ]
      },
      {
        "label": "DAY 30 - 10 MIN",
        "videos": [
          {
            "title": "MEDITATION - Deep Relaxation",
            "duration": "10:36"
          }
        ]
      },
      {
        "label": "DAY 31 - MORNING MEDITATION",
        "videos": [
          {
            "title": "MEDITATION - Good Morning. Rise and shine",
            "duration": "11:38"
          }
        ]
      },
      {
        "label": "BONUS - GOOD NIGHTS SLEEP",
        "videos": [
          {
            "title": "MEDITATION - GOOD NIGHTS SLEEP",
            "duration": "12:35"
          }
        ]
      }
    ],
    "omittedUscreenCopy": [
      "31 DAYS OF MEDITATION - INCLUDED WITH PLATINUM MEMBERSHIP"
    ]
  },
  {
    "slug": "5-day-yoga-challenge",
    "title": "5 DAY YOGA CHALLENGE - Opening the Body and the Mind",
    "uscreenPageTitle": "5 DAY YOGA CHALLENGE - Opening the Body and the Mind",
    "displayTitle": "5 Day Yoga Challenge",
    "subtitle": "Opening the Body and the Mind",
    "group": "challenge",
    "length": "5 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/collection-sly6nsg5aqa",
    "image": "/media/programs/5-day-yoga-challenge.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1662680/horizontal/big_DAY_0.001.1651376340.jpeg",
    "imageAlt": "5 DAY YOGA CHALLENGE - Opening the Body and the Mind program cover",
    "about": [
      "Join Jake Ferree for 5 days of opening the body and the mind with daily 15 minute yoga videos"
    ],
    "whoFor": [],
    "highlights": [],
    "signoff": [],
    "videoCount": 5,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 78,
    "price": {
      "label": "Rent $20.00",
      "amount": "$20.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1662680"
    },
    "sessions": [
      {
        "label": "DAY 1 - FULL BODY",
        "videos": [
          {
            "title": "5 DAY YOGA CHALLENGE - DAY 1 FULL BODY FLOW",
            "duration": "17:20"
          }
        ]
      },
      {
        "label": "DAY 2 - HIP OPENERS",
        "videos": [
          {
            "title": "5 DAY YOGA CHALLENGE - Day 2 Opening the Hips",
            "duration": "16:05"
          }
        ]
      },
      {
        "label": "DAY 3 - CORE",
        "videos": [
          {
            "title": "5 DAY YOGA CHALLENGE - DAY 3 - Yoga for the core",
            "duration": "14:54"
          }
        ]
      },
      {
        "label": "DAY 4 - OPENING THE HEART",
        "videos": [
          {
            "title": "5 DAY YOGA CHALLENGE - DAY 4 - Opening the heart",
            "duration": "13:46"
          }
        ]
      },
      {
        "label": "DAY 5 - HEALTHY SPINE",
        "videos": [
          {
            "title": "5 DAY YOGA CHALLENGE - DAY 5 - Yoga for a healthy Spine",
            "duration": "15:27"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "full-body-balance",
    "title": "FULL BODY BALANCE - 7 DAY CHALLENGE",
    "uscreenPageTitle": "FULL BODY BALANCE - 7 DAY CHALLENGE",
    "displayTitle": "Full Body Balance",
    "subtitle": "Give your whole body a little attention, one practice at a time.",
    "group": "challenge",
    "length": "7 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/collection-ndb2pmlqevw",
    "image": "/media/programs/full-body-balance.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/398956/horizontal/big_0db3d54c-1c67-4dc7-860c-d8f70b828bf4.jpeg",
    "imageAlt": "FULL BODY BALANCE - 7 DAY CHALLENGE program cover",
    "about": [
      "This seven-day yoga program takes you through a series of flows, each with a different focus. You’ll explore your hips, core, spine, chest and balance, bringing it all together through full-body practices.",
      "Each session offers a chance to build strength, create more space and notice how different areas of your body support one another. As you move through the week, you’ll develop a deeper awareness of where you feel steady, where you feel restricted and where you might find a little more ease."
    ],
    "whoFor": [
      "Follow one class each day or take more time between practices. These flows are best suited to those with some yoga experience, with room to explore at your own pace."
    ],
    "highlights": [
      "Seven yoga flow classes arranged into a seven-day journey",
      "Focused practices for the hips, core, twists, heart opening and balance",
      "Full-body flows to bring the work together",
      "One year of access to revisit your favorite sessions"
    ],
    "signoff": [
      "Come back to your body and discover how strength, flexibility and awareness can work together."
    ],
    "videoCount": 7,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 311,
    "price": {
      "label": "Rent $55.00",
      "amount": "$55.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp398956"
    },
    "sessions": [
      {
        "label": null,
        "videos": [
          {
            "title": "YOGA FLOW - Full Body Practice",
            "duration": "31:12"
          },
          {
            "title": "YOGA FLOW - Open Your HIPS",
            "duration": "44:32"
          },
          {
            "title": "YOGA FLOW - TWISTS",
            "duration": "53:33"
          },
          {
            "title": "YOGA FLOW-  THE CORE",
            "duration": "35:23"
          },
          {
            "title": "YOGA FLOW - Open The HEART",
            "duration": "36:45"
          },
          {
            "title": "YOGA FLOW - FINDING BALANCE",
            "duration": "44:39"
          },
          {
            "title": "YOGA FLOW - FULL BODY",
            "duration": "01:04:45"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "inversions-and-arm-balances",
    "title": "INVERSIONS/ARM BALANCES - 7 DAY CHALLENGE",
    "uscreenPageTitle": "INVERSIONS/ARM BALANCES - 7 DAY CHALLENGE",
    "displayTitle": "Inversions & Arm Balances",
    "subtitle": "Explore a new perspective on your practice.",
    "group": "challenge",
    "length": "7 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/inversionsandbalances",
    "image": "/media/programs/inversions-and-arm-balances.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/398969/horizontal/big_2f4822b3-5700-417c-a9ff-6be3a4953c09.png",
    "imageAlt": "INVERSIONS/ARM BALANCES - 7 DAY CHALLENGE program cover",
    "about": [
      "This seven-day yoga challenge brings together seven flowing practices and eleven focused tutorials to help you explore inversions and arm balances with greater understanding and confidence.",
      "The flows develop strength, balance and body awareness while preparing you for more challenging poses. The tutorials give you space to slow down, explore technique and revisit the details outside the pace of a full class.",
      "You’ll explore poses such as crow, flying pigeon, forearm stand and handstand, discovering how preparation, focus and small adjustments can change your experience."
    ],
    "whoFor": [
      "This program is designed for those with an established yoga practice who are ready to explore more advanced movements. You don’t need to achieve every pose to benefit. Building awareness, learning your limits and recognizing your progress are all part of the practice."
    ],
    "highlights": [
      "Seven challenging yoga practices",
      "Eleven tutorials focused on inversions and arm balances",
      "18 videos in total",
      "One year of access to repeat the flows and return to the tutorials"
    ],
    "signoff": [
      "Take your time, stay curious and give yourself room to explore."
    ],
    "videoCount": 18,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 428,
    "price": {
      "label": "Rent $77.00",
      "amount": "$77.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp398969"
    },
    "sessions": [
      {
        "label": null,
        "videos": [
          {
            "title": "YOGA FLOW - RENEWAL FLOW",
            "duration": "51:58"
          },
          {
            "title": "YOGA FLOW - Flight Balance",
            "duration": "01:06:20"
          },
          {
            "title": "BIRD FLOW",
            "duration": "54:27"
          },
          {
            "title": "YOGA FLOW - Challenge to FOREARM STAND",
            "duration": "55:55"
          },
          {
            "title": "YOGA FLOW - GROUNDED FLOW",
            "duration": "47:44"
          },
          {
            "title": "YOGA FLOW - Peak Pose - BALANCED SIDE EXTENSION",
            "duration": "49:08"
          },
          {
            "title": "YOGA FLOW - FULL BODY",
            "duration": "01:04:45"
          },
          {
            "title": "ONE LEGGED CROW TUTORIAL",
            "duration": "02:47"
          },
          {
            "title": "CROW POSE TUTORIAL",
            "duration": "03:00"
          },
          {
            "title": "FLYING PIGEON POSE TUTORIAL",
            "duration": "02:55"
          },
          {
            "title": "Forearm Tutorial",
            "duration": "06:08"
          },
          {
            "title": "8 limb pose",
            "duration": "02:48"
          },
          {
            "title": "HANDSTAND Rocking & Press",
            "duration": "02:26"
          },
          {
            "title": "HANDSTANDS",
            "duration": "04:11"
          },
          {
            "title": "HANDSTANDS Leg Swing",
            "duration": "03:02"
          },
          {
            "title": "TUTORIAL - TWISTED EKA PADA",
            "duration": "01:40"
          },
          {
            "title": "Eka Pada 2 ARM BALANCE",
            "duration": "03:54"
          },
          {
            "title": "TUTORIAL - FIREFLY POSE",
            "duration": "04:35"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "30-day-game-changer",
    "title": "30 Day Game Changer Program",
    "uscreenPageTitle": "30 Day Game Changer Program",
    "displayTitle": "30 Day Game Changer Program",
    "subtitle": "Sometimes a small shift can change the way you experience your entire practice.",
    "group": "journey",
    "length": "30 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/game_changer",
    "image": "/media/programs/30-day-game-changer.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1029390/horizontal/big_GAMECHANGER.001.1633206379.jpeg",
    "imageAlt": "30 Day Game Changer Program program cover",
    "about": [
      "Over 30 days, explore yoga, mindful fitness and meditation with simple techniques that help you move with greater awareness. These “game changers” bring a fresh perspective to familiar movements, helping you discover how focus, muscle engagement and the way you work within a pose can make a difference.",
      "The program blends flowing yoga practices with bodyweight fitness sessions to support strength, mobility and balance. You’ll use your own body for resistance, with no weights needed. Yoga and meditation sessions offer opportunities to slow down, reconnect and bring that awareness beyond your mat.",
      "Four rest days are built into the journey, giving you space to recover and notice how you feel along the way."
    ],
    "whoFor": [
      "Come with some yoga experience and a willingness to explore. You may discover a new way to approach a pose, a stronger connection to your body or a little more freedom in how you move."
    ],
    "highlights": [
      "A 30-day schedule of yoga, bodyweight fitness and meditation",
      "Four planned rest days",
      "Three bonus guided meditations",
      "Short introductory videos on Days 1, 2, 3 and 6, offering context and helpful guidance",
      "One year of access to return to the practices"
    ],
    "signoff": [],
    "videoCount": 33,
    "restDays": 4,
    "breakdown": {
      "practices": 26,
      "intros": 4,
      "bonus": 3
    },
    "totalMinutes": 1431,
    "price": {
      "label": "Rent $111.00",
      "amount": "$111.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1029390"
    },
    "sessions": [
      {
        "label": "BONUS MEDITATIONS",
        "videos": [
          {
            "title": "MEDITATION - Good Morning. Rise and shine",
            "duration": "11:38"
          },
          {
            "title": "MEDITATION - GOOD NIGHTS SLEEP",
            "duration": "12:35"
          },
          {
            "title": "MEDITATION - Quick Reset",
            "duration": "08:23"
          }
        ]
      },
      {
        "label": "DAY 1 INTRO",
        "videos": [
          {
            "title": "AMAZED DAY 1 INTRO",
            "duration": "03:17"
          }
        ]
      },
      {
        "label": "DAY 1 YOGA FLOW",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 1",
            "duration": "59:22"
          }
        ]
      },
      {
        "label": "DAY 2 INTRO TO FITNESS",
        "videos": [
          {
            "title": "AMAZED - DAY 2 INTRO",
            "duration": "01:41"
          }
        ]
      },
      {
        "label": "DAY 2 - FITNESS",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 2 - FITNESS",
            "duration": "32:37"
          }
        ]
      },
      {
        "label": "DAY 3 - INTRO",
        "videos": [
          {
            "title": "AMAZED DAY 3 INTRO",
            "duration": "03:38"
          }
        ]
      },
      {
        "label": "DAY 3 - YOGA FLOW with DIDO PLAYLIST",
        "videos": [
          {
            "title": "AMAZED- Game Changer Program Day 3",
            "duration": "01:05:32"
          }
        ]
      },
      {
        "label": "DAY 4 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 5 - YOGA & MEDITATION",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 5",
            "duration": "59:33"
          }
        ]
      },
      {
        "label": "DAY 6 - INTRO",
        "videos": [
          {
            "title": "Day 6 INTRO",
            "duration": "01:33"
          }
        ]
      },
      {
        "label": "DAY 6 - Twists",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 6",
            "duration": "58:21"
          }
        ]
      },
      {
        "label": "DAY 7 - HIPS & CHEST",
        "videos": [
          {
            "title": "Amazed - Game Changer Day 7",
            "duration": "01:03:10"
          }
        ]
      },
      {
        "label": "DAY 8 - YOGA FLOW",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 8",
            "duration": "55:14"
          }
        ]
      },
      {
        "label": "DAY 9 - MINDFUL FITNESS",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 9",
            "duration": "28:46"
          }
        ]
      },
      {
        "label": "DAY 10 - YOGA & U2",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 10",
            "duration": "58:14"
          }
        ]
      },
      {
        "label": "DAY 11 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "DAY 12 - YOGA & MEDITATION",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 12",
            "duration": "01:03:01"
          }
        ]
      },
      {
        "label": "Day 13 - Twisted Yoga flow",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 13",
            "duration": "55:15"
          }
        ]
      },
      {
        "label": "Day 14 - Yoga Flow - Open Hips",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 14",
            "duration": "59:39"
          }
        ]
      },
      {
        "label": "Day 15 - Yoga Advanced Flow",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 15",
            "duration": "53:34"
          }
        ]
      },
      {
        "label": "Day 16 - Mindful Fitness - Full Body",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 16",
            "duration": "29:21"
          }
        ]
      },
      {
        "label": "Day 17 - Yoga & RUFUS",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 17",
            "duration": "01:00:32"
          }
        ]
      },
      {
        "label": "Day 18 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "Day 19 - Yoga & Meditation",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 19",
            "duration": "57:36"
          }
        ]
      },
      {
        "label": "Day 20 - Yoga Flow with Twists",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 20",
            "duration": "59:18"
          }
        ]
      },
      {
        "label": "Day 21 - Yoga Flow - open hips and chest",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 21",
            "duration": "58:50"
          }
        ]
      },
      {
        "label": "Day 22 - Flow working towards forearm stand",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 22",
            "duration": "53:17"
          }
        ]
      },
      {
        "label": "Day 23 - Mindful Fitness",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 23",
            "duration": "29:47"
          }
        ]
      },
      {
        "label": "Day 24 - Yoga Flow with Odesza Playlist",
        "videos": [
          {
            "title": "AMAZED - Game Changer Program Day 24",
            "duration": "01:04:29"
          }
        ]
      },
      {
        "label": "Day 25 - REST",
        "videos": [],
        "rest": true
      },
      {
        "label": "Day 26 - Yoga & Meditation",
        "videos": [
          {
            "title": "YOGA + MEDITATION - Slow Flow + Healing Waters",
            "duration": "58:13"
          }
        ]
      },
      {
        "label": "Day 27 - Yoga with Twists",
        "videos": [
          {
            "title": "YOGA FLOW - Feeling Twisted",
            "duration": "58:04"
          }
        ]
      },
      {
        "label": "Day 28 - Yoga Flow - Open hips + Chest",
        "videos": [
          {
            "title": "YOGA FLOW - Opened + Balanced",
            "duration": "57:26"
          }
        ]
      },
      {
        "label": "Day 29 - Advanced Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Going with the Flow",
            "duration": "58:06"
          }
        ]
      },
      {
        "label": "Day 30 - Mindful Fitness",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Fully Fit",
            "duration": "30:59"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "rising-to-your-peak",
    "title": "RISING TO YOUR PEAK PROGRAM",
    "uscreenPageTitle": "RISING TO YOUR PEAK PROGRAM",
    "displayTitle": "Rising to Your Peak",
    "subtitle": "Explore what becomes possible when you build toward something, one practice at a time.",
    "group": "journey",
    "length": null,
    "uscreenUrl": "https://videos.feelingmoved.com/programs/rising_to_your_peak",
    "image": "/media/programs/rising-to-your-peak.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1114826/horizontal/big_RISINGTO.001.1633205191.jpeg",
    "imageAlt": "RISING TO YOUR PEAK PROGRAM program cover",
    "about": [
      "This collection of 25 videos brings together yoga, mindful fitness and meditation to help you develop strength, mobility, balance and body awareness.",
      "Many of the yoga classes build toward a “peak pose”—a posture explored later in the practice after preparing the body through purposeful movement. Along the way, you’ll discover how the steps leading up to a pose can be just as valuable as the pose itself.",
      "From standing balances and heart-opening postures to inversions and arm balances, these practices invite you to explore your abilities with curiosity and patience. Mindful fitness sessions support your strength, while yoga and meditation offer space to slow down and reconnect."
    ],
    "whoFor": [
      "This program is best suited to those with some yoga experience who are ready to explore more challenging practices. You don’t need to master every pose to benefit. There’s plenty to discover along the way."
    ],
    "highlights": [
      "25 videos featuring yoga, mindful fitness and meditation",
      "Purposeful sequences that prepare you for a variety of peak poses",
      "A guided progression, with the next video unlocking after you complete the previous one",
      "One year of access to revisit completed practices and continue exploring"
    ],
    "signoff": [],
    "videoCount": 25,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 1291,
    "price": {
      "label": "Rent $111.00",
      "amount": "$111.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1114826"
    },
    "sessions": [
      {
        "label": "RISING TO YOUR PEAK PROGRAM",
        "videos": [
          {
            "title": "RISING TO YOUR PEAK - 1 Month Specialized Program to Keep You Motivated",
            "duration": "02:14"
          }
        ]
      },
      {
        "label": "Day 1 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Hand to big toe pose",
            "duration": "01:00:57"
          }
        ]
      },
      {
        "label": "Day 2 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Wheel Pose",
            "duration": "01:00:19"
          }
        ]
      },
      {
        "label": "Day 3 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak pose - Compass",
            "duration": "57:41"
          }
        ]
      },
      {
        "label": "Day 4 - Mindful Fitness",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Lower body, Chest & Shoulders",
            "duration": "32:01"
          }
        ]
      },
      {
        "label": "Day 5 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - SPLITS",
            "duration": "01:02:07"
          }
        ]
      },
      {
        "label": "Day 6 - Yoga + Meditation",
        "videos": [
          {
            "title": "YOGA + MEDITATION - Mellow Peak Pose - hand to big toe poses",
            "duration": "54:14"
          }
        ]
      },
      {
        "label": "Day 7 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Vegas Lessons + Twisted Peak Poses",
            "duration": "55:48"
          }
        ]
      },
      {
        "label": "Day 8 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - In Prep for Peak Pose - Visvamitrasana",
            "duration": "51:19"
          }
        ]
      },
      {
        "label": "Day 9 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Handstand",
            "duration": "56:43"
          }
        ]
      },
      {
        "label": "Day 10 - Mindful Fitness",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Legs + Abs",
            "duration": "30:37"
          }
        ]
      },
      {
        "label": "Day 11 - Yoga Flow + Trivia!",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Headstand - Plus Trivia",
            "duration": "01:01:41"
          }
        ]
      },
      {
        "label": "Day 12 - Yoga + Meditation",
        "videos": [
          {
            "title": "YOGA + MEDITATION - Mmm-Mellow + Mmm-Meditative",
            "duration": "59:53"
          }
        ]
      },
      {
        "label": "Day 13 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Firefly",
            "duration": "56:47"
          }
        ]
      },
      {
        "label": "Day 14 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Wide Leg Splits",
            "duration": "57:44"
          }
        ]
      },
      {
        "label": "Day 15 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Forearm Stand",
            "duration": "57:41"
          }
        ]
      },
      {
        "label": "Day 16 - Mindful Fitness",
        "videos": [
          {
            "title": "MINDFUL FITNESS - 45 Second Intervals",
            "duration": "30:26"
          }
        ]
      },
      {
        "label": "Day 17 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Open Heart to Wheel Pose",
            "duration": "01:02:21"
          }
        ]
      },
      {
        "label": "Day 18 - Yoga + Meditation",
        "videos": [
          {
            "title": "YOGA + MEDITATION - Calming the Chaos",
            "duration": "01:01:44"
          }
        ]
      },
      {
        "label": "Day 19 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Visvamitrasana",
            "duration": "59:21"
          }
        ]
      },
      {
        "label": "Day 20 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Dancer",
            "duration": "55:08"
          }
        ]
      },
      {
        "label": "Day 21 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - WOLF ENERGY",
            "duration": "58:50"
          }
        ]
      },
      {
        "label": "Day 22 - Mindful Fitness",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Just Core",
            "duration": "35:02"
          }
        ]
      },
      {
        "label": "Day 23 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Twisted Eka Pada",
            "duration": "59:15"
          }
        ]
      },
      {
        "label": "Day 24 - Yoga Flow",
        "videos": [
          {
            "title": "YOGA FLOW - Peak Pose - Hand to Big Toe Side Extension",
            "duration": "51:22"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  },
  {
    "slug": "fit-and-flexible-in-21-days",
    "title": "FIT & FLEXIBLE IN 21 DAYS",
    "uscreenPageTitle": "FIT & FLEXIBLE IN 21 DAYS",
    "displayTitle": "Fit & Flexible in 21 Days",
    "subtitle": "Build strength, create space and discover more ease in how you move.",
    "group": "journey",
    "length": "21 days",
    "uscreenUrl": "https://videos.feelingmoved.com/programs/fitflexible",
    "image": "/media/programs/fit-and-flexible-in-21-days.jpg",
    "imageSource": "https://alpha.uscreencdn.com/1110xnull/images/programs/1005760/horizontal/big_FITF.001.1633207865.jpeg",
    "imageAlt": "FIT & FLEXIBLE IN 21 DAYS program cover",
    "about": [
      "This 21-day program brings together bodyweight fitness, yoga and meditation to help you develop a balanced practice. Some days you’ll focus on strength and stability. Other days you’ll stretch, flow or slow down and reconnect.",
      "Each week includes three mindful fitness sessions, three yoga practices and one guided meditation. The variety gives you room to explore different ways of moving while building a consistent connection with your body.",
      "The fitness sessions use your own body for resistance, so no weights are needed. Yoga supports mobility, flexibility and balance, while meditation offers space to notice how you feel and bring more awareness into your day."
    ],
    "whoFor": [],
    "highlights": [
      "21 videos arranged into a three-week journey",
      "Three bodyweight fitness sessions each week",
      "Three yoga practices each week",
      "One guided meditation each week",
      "One year of access to revisit the practices"
    ],
    "signoff": [
      "Follow the daily sequence or take more time when you need it. Let each practice be an opportunity to listen to your body, explore your abilities and build confidence along the way."
    ],
    "videoCount": 21,
    "restDays": null,
    "breakdown": null,
    "totalMinutes": 602,
    "price": {
      "label": "Rent $111.00",
      "amount": "$111.00",
      "currency": "USD",
      "term": "for 1 year rental",
      "offer": "RENT COLLECTION (1 YEAR)",
      "url": "https://videos.feelingmoved.com/buy/new?o=rp1005760"
    },
    "sessions": [
      {
        "label": "DAY 1 - MINDFUL FITNESS - FULL BODY",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Complete Body Fit",
            "duration": "31:20"
          }
        ]
      },
      {
        "label": "DAY 2 - YOGA FLOW - BEGINNER FLOW",
        "videos": [
          {
            "title": "YOGA FLOW - Full Body Practice",
            "duration": "31:12"
          }
        ]
      },
      {
        "label": "DAY 3 - MINDFUL FITNESS - LOWER BODY",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Lower Body",
            "duration": "29:53"
          }
        ]
      },
      {
        "label": "DAY 4 - YOGA FLOW - ALL LEVELS",
        "videos": [
          {
            "title": "YOGA FLOW - Open Your HIPS",
            "duration": "44:32"
          }
        ]
      },
      {
        "label": "DAY 5 - MINDFUL FITNESS - QUICK FULL BODY",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Yoga Inspired Strength and Flow ",
            "duration": "09:29"
          }
        ]
      },
      {
        "label": "DAY 6 - SLOW STRETCH",
        "videos": [
          {
            "title": "YOGA FLOW - Everyday Stretch and Flow",
            "duration": "15:56"
          }
        ]
      },
      {
        "label": "DAY 7 - MEDITATION - BODY APPRECIATION",
        "videos": [
          {
            "title": "MEDITATION Body Appreciation",
            "duration": "23:30"
          }
        ]
      },
      {
        "label": "DAY 8 - MINDFUL FITNESS - FULL BODY",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Full Body Fit",
            "duration": "30:48"
          }
        ]
      },
      {
        "label": "DAY 9 - YOGA FLOW - TWISTING & BALANCE",
        "videos": [
          {
            "title": "YOGA FLOW - Better things can fall together - TWIST & BALANCE",
            "duration": "45:51"
          }
        ]
      },
      {
        "label": "DAY 10 - MINDFUL FITNESS - LOWER BODY FOCUS",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Frisky Fit",
            "duration": "31:00"
          }
        ]
      },
      {
        "label": "DAY 11 - YOGA FLOW - FOCUS ON STRETCHING CHEST AND SHOULDERS",
        "videos": [
          {
            "title": "YOGA FLOW - Heart Opening Flow",
            "duration": "36:45"
          }
        ]
      },
      {
        "label": "DAY 12 - MINDFUL FITNESS - QUICK CORE",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Quick Cardio Core",
            "duration": "12:10"
          }
        ]
      },
      {
        "label": "DAY 13 - SLOW STRETCH",
        "videos": [
          {
            "title": "YOGA FLOW - Everyday Floor",
            "duration": "24:46"
          }
        ]
      },
      {
        "label": "DAY 14 - MEDITATION - FINDING YOUR PEACEFUL PLACE",
        "videos": [
          {
            "title": "MEDITATION - Finding your peaceful place",
            "duration": "10:36"
          }
        ]
      },
      {
        "label": "DAY 15 - MINDFUL FITNESS - FULLL BODY",
        "videos": [
          {
            "title": "FIT - Mindful Fitness",
            "duration": "30:45"
          }
        ]
      },
      {
        "label": "DAY 16 - YOGA FLOW - CORE INSPIRED",
        "videos": [
          {
            "title": "YOGA FLOW - CORE FLOW",
            "duration": "38:39"
          }
        ]
      },
      {
        "label": "DAY 17 - MINDFUL FITNESS - LOWER BODY",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Lower Body Fit",
            "duration": "32:00"
          }
        ]
      },
      {
        "label": "DAY 18 - YOGA FLOW - COMPASSION",
        "videos": [
          {
            "title": "YOGA FLOW- SWORD IN THE STONE - FLOWING INTO A PLACE OF COMPASSION",
            "duration": "01:06:00"
          }
        ]
      },
      {
        "label": "DAY 19 - MINDFUL FITNESS - QUICK CORE",
        "videos": [
          {
            "title": "MINDFUL FITNESS - Quick Core Blast",
            "duration": "12:43"
          }
        ]
      },
      {
        "label": "DAY 20 - SLOW STRETCH",
        "videos": [
          {
            "title": "GET UP SIT UP",
            "duration": "15:35"
          }
        ]
      },
      {
        "label": "DAY 21 - MEDITATION - GRATITUDE FOR THE BODY",
        "videos": [
          {
            "title": "MEDITATION- Gratitude for the body",
            "duration": "28:50"
          }
        ]
      }
    ],
    "omittedUscreenCopy": []
  }
];
